<template>
  <div class="homepage" data-model-id="3396:357">
    <div class="overlap">
      <div class="background">
        <div class="overlap-group">
          <div class="div">
            <img
              class="freepik-green"
              alt="Freepik green"
              src="/img/freepik-green-landscape-agriculture-bio-nature-80960-1-2.webp"
              decoding="async"
              fetchpriority="high"
            />
          </div>

          <div class="rectangle" />

          <div class="rectangle-2" />
        </div>
      </div>
      <div class='main-container'>
        <p class="bigtitle">
          Syndicat Malgache de l&#39;Agriculture Biologique
        </p>

        <p class="text-wrapper">
          Le syndicat compte +70 membres exerçant des activités dans la filière
          bio et disposant de certificats de conformité de leurs produits
          biologiques.
        </p>
        <div class='btn-group'>
          <router-link to='/pagemembres'>
            <button class="button">
              <div class="text-btn">Voir tous les membres</div>
            </button>
          </router-link>
          <router-link to='/reglement'>
            <button class="button-secondary">
              <div class="text-btn">Rejoindre Symabio</div>
            </button>
          </router-link>
        </div>
        
        <!-- Elegant Info Panel -->
        <div class="info-panel">
          <div class="info-content">
            <div class="info-header">
              <span class="info-badge">Agriculture Biologique</span>
              <span class="info-stats">Syndicat Professionnel</span>
            </div>
            <h3 class="info-title">Excellence & Expertise</h3>
            <p class="info-description">
              Nous accompagnons les producteurs malgaches dans leur transition vers une agriculture durable, 
              respectueuse de l'environnement et certifiée selon les standards internationaux.
            </p>
            <div class="info-footer">
              <span class="info-tagline">Votre partenaire de confiance pour l'agriculture biologique à Madagascar</span>
            </div>
          </div>
        </div>
          <footer class="footer">
            <div class="social-media">
              <a
                class="img-wrapper-2 social-link"
                href="https://www.facebook.com/symabio"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
                aria-label="Ouvrir Facebook Symabio dans un nouvel onglet"
              >
                <img
                  class="img-2"
                  alt="Facebook"
                  src="/img/gg-facebook.svg"
                  loading="lazy" decoding="async" fetchpriority="low"
                  width="24" height="24"
                />
              </a>

              <a
                class="img-wrapper-2 social-link"
                href="https://www.instagram.com/symabio/"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
                aria-label="Ouvrir Instagram Symabio dans un nouvel onglet"
              >
                <img
                  class="img-2"
                  alt="Instagram"
                  src="/img/akar-icons-instagram-fill.svg"
                  loading="lazy" decoding="async" fetchpriority="low"
                  width="24" height="24"
                />
              </a>

              <a
                class="img-wrapper-2 social-link"
                href="https://www.linkedin.com/company/symabio/"
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
                aria-label="Ouvrir LinkedIn Symabio dans un nouvel onglet"
              >
                <img
                  class="img-2"
                  alt="LinkedIn"
                  src="/img/formkit-linkedin.svg"
                  loading="lazy" decoding="async" fetchpriority="low"
                  width="24" height="24"
                />
              </a>
            </div>

            <div class="contact">
              <a
                class="call"
                href="tel:+261341130221"
                title="Appeler +261 34 11 302 21"
                aria-label="Appeler Symabio"
              >
                <img
                  class="img-2"
                  alt="Téléphone"
                  src="/img/fluent-call-24-filled.svg"
                  loading="lazy" decoding="async" fetchpriority="low"
                  width="24" height="24"
                />
                <p class="text-contact">+261 34 11 302 21</p>
              </a>

              <a
                class="email"
                href="mailto:se.symabio@gmail.com"
                title="Envoyer un email à se.symabio@gmail.com"
                aria-label="Envoyer un email à Symabio"
              >
                <img
                  class="img-2"
                  alt="Email"
                  src="/img/ic-round-email.svg"
                  loading="lazy" decoding="async" fetchpriority="low"
                  width="24" height="24"
                />
                <p class="text-contact">se.symabio@gmail.com</p>
              </a>
            </div>
            <p class="copyright">
              Copyright © 2025 Symabio - Tous droits réservés
            </p>
        </footer>
        </div>

        
    </div>
    <!-- Header with better background -->
    <header class="main-header">
      <router-link to="/" class="logo">
        <img
          class="logo-symabio"
          alt="Logo symabio"
          src="/img/logo-symabio.png"
          decoding="async"
          fetchpriority="high"
          width="256" height="64"
        />
      </router-link>

      <div class='burger-wrapper' v-show="tmode || mmode">
        <button class="burger-button" @click="toggleMobileMenu">
          <div class='line1' :class="{ 'active': mobileMenuOpen }"></div>
          <div class='line2' :class="{ 'active': mobileMenuOpen }"></div>
        </button>
      </div>
      
      <div class="navbar" v-show="wsmode">
        <router-link to="/" class="navbar-item">
          <span class="nav-text">Accueil</span>
          <div class="nav-underline"></div>
        </router-link>
        <router-link to="/about" class="navbar-item">
          <span class="nav-text">Symabio</span>
          <div class="nav-underline"></div>
        </router-link>
        <router-link to="/pagemembres" class="navbar-item">
          <span class="nav-text">Membres</span>
          <div class="nav-underline"></div>
        </router-link>
        <router-link to="/reglement" class="navbar-item">
          <span class="nav-text">Réglementations</span>
          <div class="nav-underline"></div>
        </router-link>
      </div>
    </header>

    <!-- Mobile Menu -->
    <div class="mobile-menu-overlay" v-show="mobileMenuOpen" @click="closeMobileMenu"></div>
    <div class="mobile-menu" :class="{ 'active': mobileMenuOpen }" v-show="tmode || mmode">
      <div class="mobile-menu-header">
        <img src="/img/logo-symabio.png" alt="Logo Symabio" class="mobile-logo" />
      </div>
      <div class="mobile-menu-links">
        <router-link to="/" class="mobile-navbar-item" @click="closeMobileMenu">Accueil</router-link>
        <router-link to="/about" class="mobile-navbar-item" @click="closeMobileMenu">Symabio</router-link>
        <router-link to="/pagemembres" class="mobile-navbar-item" @click="closeMobileMenu">Membres</router-link>
        <router-link to="/reglement" class="mobile-navbar-item" @click="closeMobileMenu">Réglementations</router-link>
      </div>
      <div class="mobile-menu-footer">
        <div class="social-icons">
          <a href="https://www.facebook.com/symabio" class="social-icon"><img src="/img/gg-facebook.svg" alt="Facebook" loading="lazy" decoding="async" fetchpriority="low" width="32" height="32"></a>
          <a href="https://www.linkedin.com/company/symabio/" class="social-icon"><img src="/img/formkit-linkedin.svg" alt="LinkedIn" loading="lazy" decoding="async" fetchpriority="low" width="32" height="32"></a>
          <a href="#" class="social-icon"><img src="/img/akar-icons-instagram-fill.svg" alt="Instagram" loading="lazy" decoding="async" fetchpriority="low" width="32" height="32"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homepage",
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
  props:{
    wsmode:{
        type: Boolean,
        default: false
      },
    tmode:{
      type: Boolean,
      default: false
    },
    mmode:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.classList.remove('no-scroll');
    }
  }
};
</script>

<style>
.homepage {
  height: 100vh;/*1098px;*/
  overflow: hidden;
  position: relative;
  width: 100vw;/*1440px;*/
}

/* Main Header */
.homepage .main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  background: linear-gradient(180deg, 
    rgba(0,0,0,0.8) 0%, 
    rgba(0,0,0,0.6) 50%, 
    rgba(0,0,0,0.4) 80%, 
    rgba(0,0,0,0.2) 100%
  );
  backdrop-filter: blur(10px);
  z-index: 1001;
  transition: background 0.3s ease;
}

.homepage .burger-wrapper {
  z-index: 2000;
  position: absolute;
  right: 2vw;
  top: 56px;
}
.homepage .burger-button {
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end ;
  justify-content: center;
  gap:6px;
  cursor: pointer;
  background: none;
  border: none;
}
.homepage .line1,.homepage .line2{
  border-radius: 2px;
  background: #ffffff;
  height: 3.1px;
  transition: all 0.5s ease-in-out;
}
.homepage .line1{
  width: 40px;
}
.homepage .line2{
  width: 30px;
}

/* Burger menu animation when active */
.homepage .line1.active {
  transform: rotate(45deg) translate(6px, 6px);
}
.homepage .line2.active {
  transform: rotate(-45deg) translate(7px, -7px);
  width: 40px;
}

/* Mobile Menu */
.homepage .mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1998;
}

.homepage .mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 300px;
  height: 100vh;
  background: #fff;
  z-index: 1999;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
}

.homepage .mobile-menu.active {
  right: 0;
}

.homepage .mobile-menu-header {
  padding: 24px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.homepage .mobile-logo {
  height: 60px;
  width: auto;
}

.homepage .mobile-menu-links {
  flex: 1;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.homepage .mobile-navbar-item {
  display: block;
  padding: 16px 24px;
  color: #000;
  text-decoration: none;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 18px;
  font-weight: 300;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s ease;
}

.homepage .mobile-navbar-item:hover {
  background-color: #f8f9fa;
}

.homepage .mobile-navbar-item.router-link-active {
  background-color: #3b723e;
  color: white;
}

.homepage .mobile-menu-footer {
  padding: 24px;
  border-top: 1px solid #eee;
}

.homepage .social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.homepage .social-icon {
  display: block;
  width: 32px;
  height: 32px;
}

.homepage .social-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Global no-scroll class */
.no-scroll {
  overflow: hidden;
}

/* Navigation Styling */
.homepage .navbar {
  align-items: center;
  display: inline-flex;
  gap: 4vw;
  right: 3vw;
  position: fixed;
  top: 52px;
}

.homepage .navbar-item {
  color: rgba(255, 255, 255, 0.85);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 24px;
  text-decoration: none;
  white-space: nowrap;
  width: fit-content;
  position: relative;
  padding: 8px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.homepage .nav-text {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.homepage .nav-underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a);
  transform: translateX(-50%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(59, 114, 62, 0.4);
}

/* Normal hover effect */
.homepage .navbar-item:hover {
  color: #ffffff;
  transform: translateY(-1px);
}

.homepage .navbar-item:hover .nav-underline {
  width: 100%;
  box-shadow: 0 4px 12px rgba(59, 114, 62, 0.6);
}

.homepage .navbar-item:hover .nav-text {
  text-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
}

/* Active page styling (router-link-active) */
.homepage .navbar-item.router-link-active {
  color: #ffffff;
  font-weight: 400;
  transform: translateY(-1px);
}

.homepage .navbar-item.router-link-active .nav-text {
  text-shadow: 0 2px 12px rgba(255, 255, 255, 0.4);
  background: linear-gradient(135deg, #ffffff, #e8f5e8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.homepage .navbar-item.router-link-active .nav-underline {
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a, #4caf50, #3b723e);
  background-size: 200% 100%;
  animation: shimmer 2s ease-in-out infinite;
  box-shadow: 
    0 2px 8px rgba(59, 114, 62, 0.6),
    0 0 20px rgba(76, 175, 80, 0.3);
}

.homepage .navbar-item.router-link-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(59, 114, 62, 0.1) 0%, transparent 70%);
  border-radius: 8px;
  z-index: 1;
  opacity: 0;
  animation: glow 2s ease-in-out infinite alternate;
}

/* Enhanced hover effect for active page */
.homepage .navbar-item.router-link-active:hover {
  transform: translateY(-2px);
}

.homepage .navbar-item.router-link-active:hover .nav-text {
  text-shadow: 0 4px 16px rgba(255, 255, 255, 0.5);
}

.homepage .navbar-item.router-link-active:hover .nav-underline {
  height: 4px;
  box-shadow: 
    0 4px 16px rgba(59, 114, 62, 0.8),
    0 0 30px rgba(76, 175, 80, 0.5);
}

/* Animations */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes glow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* Logo styling */
.homepage .logo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 7vw;
  padding: 10px;
  position: fixed;
  top: 24px;
  z-index: 1002;
}

.homepage .logo-symabio {
  align-self: stretch;
  height: 64px;
  object-fit: cover;
  position: relative;
  width: 100%;
  transition: all 0.3s ease;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

.homepage .logo:hover .logo-symabio {
  transform: scale(1.05);
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4));
}
.homepage .overlap {
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
  scrollbar-color: rgba(76, 175, 79, 0.01) transparent;
  overflow-x: hidden;
  scrollbar-width: none;
}
/* Chrome, Edge, Safari */
.homepage .overlap::-webkit-scrollbar {
  width: 8px;
}

.homepage .overlap::-webkit-scrollbar-track {
  background: transparent;
}

.homepage .overlap::-webkit-scrollbar-thumb {
  background-color: #4caf50;
  border-radius: 4px;
}

.homepage .background {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.homepage .overlap-group {
  height: 100%;
  position: relative;
}
.homepage .main-container{
  position: relative;
  margin-top: 120px;
  height: -webkit-fill-available;
}
.homepage .freepik-green {
  object-fit: cover;
  position: fixed;
  top: 0;
  width: -webkit-fill-available;
  z-index:-999;
  animation: parallax 3s ease-in;
}

@keyframes parallax {
  0%{
    scale: 1.5;
  }
  100%{
    scale: 1;
  }
}
.homepage .rectangle {
  background-color: #01010191;
  height: 100%;
  position: fixed;
  top: 0;
  transform: rotate(180deg);
  width: 100%;
  z-index:-999;
}

.homepage .rectangle-2 {
  background: linear-gradient(155deg, #0000002e 60%, #00000066 92%, #0000002e 100%
  );
  height: 100%;
  position: fixed;
  top: 0;
  transform: rotate(180deg);
  width: 100%;
  z-index:-999;
}

.homepage .bigtitle {
  color: #ffffff;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 4vw;
  font-weight: 300;
  /* left: 8vw; */
  letter-spacing: 0;
  line-height: normal;
  width: 40%;
  margin: 24px 8vw 24px  8vw;
}

.homepage .text-wrapper {
  color: #ffffff;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  /* left: 8vw; */
  letter-spacing: 0;
  line-height: 24px;
  margin: 12px 8vw ;
  padding: 0px 12px;
  /* position: absolute; */
  /* top: 50%; */
  width: 32%;
}
.homepage .btn-group{
  display: flex;
  gap: 12px; 
  left: 8vw;
  margin: 24px 8vw ;
  top: 64%; 
}
.homepage .button , .homepage .text-button, .homepage .button-secondary{
  all: unset;
  background-color: #e6e3b540;
  border-radius: 100px;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  height: 58px;
  width: 296px;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.homepage .button-secondary {
  background-color: transparent;
  border: 2px solid #e6e3b540;
}

.homepage .button:hover {
  background-color: #e6e3b560;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.homepage .button-secondary:hover {
  background-color: #e6e3b520;
  border-color: #e6e3b580;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.homepage .text-button{
  background-color:unset;
  border: 1px solid #e6e3b540;
}
.homepage .text-btn {
  color: #ffffff;
  font-family: "Mona-Sans", Helvetica;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}
.homepage .text-button .text-btn{
  font-weight: 300;
}
/* Elegant Info Panel */
.homepage .info-panel {
  margin: 100px 8vw 80px 8vw;
  max-width: 600px;
  position: relative;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 40px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}

.homepage .info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.homepage .info-badge {
  background: linear-gradient(135deg, #3b723e, #2d5a31);
  color: white;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 10px 20px;
  border-radius: 25px;
  display: inline-block;
  box-shadow: 0 6px 20px rgba(59, 114, 62, 0.3);
  position: relative;
  overflow: hidden;
}

.homepage .info-badge::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.6s ease;
}

.homepage .info-badge:hover::before {
  left: 100%;
}

.homepage .info-stats {
  color: rgba(255, 255, 255, 0.8);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 14px;
  font-weight: 300;
  font-style: italic;
  letter-spacing: 0.5px;
}

.homepage .info-title {
  color: #ffffff;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-size: 36px;
  font-weight: 600;
  margin: 0 0 24px 0;
  letter-spacing: -0.02em;
  text-shadow: 0 3px 15px rgba(0, 0, 0, 0.4);
  line-height: 1.1;
  background: linear-gradient(135deg, #ffffff, #e8f5e8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.homepage .info-description {
  color: rgba(255, 255, 255, 0.9);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.7;
  margin: 0 0 32px 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  max-width: 520px;
  letter-spacing: 0.03em;
}

.homepage .info-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: 28px;
  margin-top: 28px;
}

.homepage .info-tagline {
  color: rgba(255, 255, 255, 0.75);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 15px;
  font-weight: 300;
  font-style: italic;
  letter-spacing: 0.5px;
  line-height: 1.6;
  display: block;
  text-align: left;
}

.homepage .footer {
  /* background-color: #e8e8e8; */
  height: 73px;
  padding: 0px 8vw;
  /* position: relative; */
  bottom: 0;
  width: 100vw;
  display: grid;
  grid-template-columns:16% 1fr 25%;
  align-items: center;
}

.homepage .copyright {
  color: #ffffffcc;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  /* left: 1051px; */
  letter-spacing: 0;
  line-height: 24px;
  /* position: absolute; */
  /* top: 24px; */
  white-space: nowrap;
}

.homepage .social-media {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  /* left: 8vw; */
  /* position: absolute; */
  /* top: 17px; */
}

.homepage .img-wrapper-2 {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  padding: 8px;
  position: relative;
}

.homepage .img-2 {
  height: 24px;
  position: relative;
  width: 24px;
}

.homepage .contact {
  align-items: flex-start;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  /* left: 286px; */
  /* position: absolute; */
  /* top: 25px; */
  width: max-content;
}

/* Enhanced pill design for contact links */
.homepage .call,
.homepage .email {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  position: relative;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 14px; /* larger click target */
  border-radius: 9999px; /* pill */
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
}

.homepage .call:hover,
.homepage .email:hover {
  background: rgba(230, 227, 181, 0.18); /* theme tint */
  border-color: rgba(230, 227, 181, 0.55);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}

.homepage .call:focus-visible,
.homepage .email:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 114, 62, 0.45), 0 6px 18px rgba(0, 0, 0, 0.25);
}

/* Icon and text micro-interactions */
.homepage .call .img-2,
.homepage .email .img-2 {
  transition: transform 0.2s ease, filter 0.25s ease;
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
}

.homepage .call:hover .img-2,
.homepage .email:hover .img-2 {
  transform: scale(1.08);
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));
}

.homepage .text-contact {
  color: #ffffffcc;
  font-family: var(--text-font-family);
  font-size: var(--text-font-size);
  font-style: var(--text-font-style);
  font-weight: var(--text-font-weight);
  letter-spacing: var(--text-letter-spacing);
  line-height: var(--text-line-height);
  position: relative;
  width: fit-content;
  transition: color 0.25s ease, text-shadow 0.25s ease;
}

.homepage .call:hover .text-contact,
.homepage .email:hover .text-contact {
  color: #ffffff;
  text-shadow: 0 1px 8px rgba(255, 255, 255, 0.25);
}

/* Keep existing .email spacing slightly larger */
.homepage .email { gap: 12px; }

@media (max-width: 773px){
  .homepage .contact { gap: 16px; }
  .homepage .call,
  .homepage .email {
    padding: 8px 12px;
  }
}
@media (max-height: 1200px){
  .homepage .freepik-green {
    height: -webkit-fill-available;
    animation: parallax 2s ease-in;
  }
}
@media (max-width: 1024px){
  .homepage .main-header {
    height: 100px;
  }
  
  .homepage .logo {
    left: 4vw;
    top: 18px;
  }
  
  .homepage .logo-symabio {
    height: 56px;
  }
  
  .homepage .burger-wrapper {
    right: 4vw;
    top: 42px;
    z-index: 2000;
  }
  
  .homepage .navbar {
    top: 40px;
  }
  
  .homepage .main-container {
    margin-top: 16vh;
  }
  .homepage .bigtitle {
    font-size: 7.2vw;
    width: 80%;
    margin: 0vh 8vw 32px 8vw;
  }
  .homepage .text-wrapper {
    width: 60%;
    margin: 24px 8vw;
  }

  .homepage .footer {
    grid-template-columns: 1fr 1fr;
    padding: 24px 8vw;
  }
  
  /* Info Panel Responsive */
  .homepage .info-panel {
    margin: 80px 4vw 60px 4vw;
    max-width: 100%;
    display: flex;
    justify-content: center;
    padding: 32px 24px;
  }
  
  .homepage .info-content {
    width: 100%;
    max-width: 550px;
    text-align: center;
  }
  
  .homepage .info-header {
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }
  
  .homepage .info-title {
    font-size: 30px;
  }
  
  .homepage .info-description {
    font-size: 16px;
    text-align: center;
  }
  
  .homepage .info-tagline {
    text-align: center;
  }
  
  .homepage .btn-group {
    flex-direction: column;
    gap: 16px;
    margin: 32px 8vw;
  }
  
  .homepage .button, .homepage .text-button, .homepage .button-secondary {
    width: 100%;
    max-width: 320px;
  }
}
@media (max-width: 773px){
  .homepage .main-header {
    height: 90px;
  }
  
  .homepage .logo {
    left: 4vw;
    top: 15px;
  }
  
  .homepage .logo-symabio {
    height: 48px;
  }
  
  .homepage .burger-wrapper {
    right: 4vw;
    top: 35px;
    z-index: 2000;
  }
  
  .homepage .navbar {
    top: 35px;
  }
  
  .homepage .element-membres {
    display: none; 
  }
  
  .homepage .btn-group {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 32px 8vw;
  }
  
  .homepage .button, .homepage .text-button, .homepage .button-secondary {
    width: 100%;
    max-width: 280px;
    font-size: 18px;
    height: 52px;
  }
  
  .homepage .bigtitle {
    font-size: 48px;
    width: calc(100% - 16vw);
    margin: 24px 8vw 24px 8vw;
  }
  
  .homepage .text-wrapper {
    width: calc(100% - 16vw);
    margin: 24px 8vw;
    padding: 0;
  }
  
  .homepage .footer {
    padding: 24px 7vw;
    grid-template-columns: 1fr;
    gap: 20px;
    height: auto;
    text-align: center;
  }
  
  .homepage .contact {
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }
  
  .homepage .mobile-menu {
    width: 280px;
  }
}

</style>